module.exports = __webpack_public_path__ + "media/hyper/images/flags/us-0303fcc4ecbc36888c29fdcdb2ddc8af.jpg";